import request from "@/utils/request";
// import { objectToQuerystring } from "@/utils/filters";

export function fetchCountries() {
  return request({
    url: `api/admin-panel/countries`,
    params: { pagination: "all", simple: true },
    method: "get"
  });
}
